import React from 'react';
import chatIcon from '../images/chatbot.svg';
import closeIcon from '../images/close.png';
import {unfolder} from "../lib";

class ChatBot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showChat: 0,
            token: null
        }

        this.showChatList = this.showChatList.bind(this);
        this.hideChatList = this.hideChatList.bind(this);
    }

    componentDidMount() {
        this.setState({
            token: unfolder(localStorage.getItem('hashUser'), 'IAIvaFactoryKey').token
        });
    }

    showChatList(){
        this.setState({
            showChat: 1
        });
    }

    hideChatList(){
        this.setState({
            showChat: 0
        });
    }

    render() {
        return (
            <div style={{zIndex: 100000000, minWidth: 285}}>
                <div style={{position: 'fixed', left: 15, bottom: 15}}>
                    <button onClick={this.showChatList} style={{border: 'none !important', backgroundColor: 'transparent !important'}}>
                        <img src={chatIcon} style={{height: 40, width: 40, }} />
                    </button>
                </div>

                <div style={{position: 'fixed', left: 0, bottom: 0}}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                        <button onClick={this.hideChatList} style={{border: 'none !important', backgroundColor: 'transparent !important'}}>
                            <img src={closeIcon} style={{height: 20, width: 20}} />
                        </button>
                    </div>
                    <iframe src={process.env.REACT_APP_IVA_FACTORY_CHATBOT_URL + `?project=${this.props.project.name}`} style={{height: 'auto !important'}}
                            permissions="geolocation notifications midi" frameBorder="0"/>

                </div>
            </div>
        );
    }
}

export default ChatBot;